import FileSuccess from "assets/img/svg/fileSuccess";
import Import from "assets/img/svg/import";
import classNames from "classnames";
import MessageBlock from "components/shared/MessageBlock";
import StyledButton from "components/shared/StyledButton";
import DropZoneCSV from "components/shared/UploadCsv";
import { downloadFile } from "helpers/utils";
import type { CSSProperties, ReactNode } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import variables from "../../../../assets/styles/_variables.module.scss";
import styles from "./style.module.scss";

export const quarterList = ["Year", "Quarter1", "Quarter2", "Quarter3", "Quarter4"];

interface ImportFileProps {
    onFileUpload: (data: File) => void;
    quarter: number;
}

export default function ImportFile(props: ImportFileProps) {
    const { onFileUpload } = props;
    const [t] = useTranslation();

    const [files, setFiles] = useState<File[]>([]);
    const [hasFileError, setHasFileError] = useState(false);
    const [errorState, setErrorState] = useState(false);

    const handleSetFile = (file: File[]) => {
        setFiles(file);
        setErrorState(false);
    };

    const handleNextStep = () => {
        // File validation
        if (files.length !== 1) {
            setErrorState(true);
            return toast.error(`${t("Declare.FileLengthError")}`);
        }
        if (files[0].size > 5000000) {
            setErrorState(true);
            return setHasFileError(true);
        }
        setErrorState(false);
        onFileUpload(files[0]);
    };

    const handleFileDownload = (fileName: string) => {
        const linkSource = `/${fileName}`;
        downloadFile({ source: linkSource, fileName, isLink: true });
    };

    return (
        <div className={styles.Importer}>
            <div className="step-header">
                <h1>{t("Declare.ImportStep.Title")}</h1>
                <p
                    style={{
                        textAlign: "center",
                        fontSize: "14px",
                        fontWeight: 400,
                        color: variables["foreground"],
                    }}
                >
                    {t("Declare.ImportStep.Subtitle")}
                </p>
            </div>

            <div className={styles["import-steps"]}>
                <div className={styles["import-step"]}>
                    <div className={styles["import-step-title"]}>{t("Declare.Step")} 1</div>
                    <p>
                        {/* Préparez un tableur avec vos paiements {props.quarter == 0 ? "de l'" : "du "}{t(`Declare.${quarterList[props.quarter]}`)} aux bénéficiaires selon le modèle du fichier exemple. */}
                        {t("Declare.ImportStep.Step1", {
                            count: props.quarter,
                            quarter: t(`Declare.${quarterList[props.quarter]}`),
                        })}
                    </p>
                    <div className={styles["import-step-files-download"]}>
                        <FileButton
                            label={t("Declare.ImportStep.DownloadExampleFile")}
                            onClick={() => handleFileDownload("exemple-fichier-declaratif.xlsx")}
                        />
                        <FileButton
                            label={t("Declare.ImportStep.DownloadGuide")}
                            link="https://ma-declaration-urssaf.crealo.app/aide-declaration.pdf"
                            filename="aide-declaration.pdf"
                        />
                    </div>
                </div>
                <div className={styles["import-step"]}>
                    <div className={styles["import-step-title"]}>{t("Declare.Step")} 2</div>
                    <p>{t("Declare.ImportStep.Step2")}</p>
                    {hasFileError && (
                        <p style={{ color: "#9B5067" }}>
                            {t("Declare.ImportStep.FileTooBig")}
                            <br />({t("Declare.ImportStep.PossibleEmptyLines")})
                        </p>
                    )}
                    <DropZoneCSV
                        setFile={handleSetFile}
                        file={files}
                        style={{ minHeight: 0 }}
                        compact
                        error={errorState}
                    />
                    {errorState && <MessageBlock text={t("Declare.ImportStep.ErrorState")} type="error" />}
                </div>
            </div>

            <StyledButton
                buttonType="primary"
                fullWidth
                onClick={handleNextStep}
                // disabled={files.length == 0}
            >
                {/* {files.length == 0 ? t("Declare.CantNext") : t("Declare.Next")} */}
                {t("Declare.Next")}
            </StyledButton>
        </div>
    );
}

interface FileButtonProps {
    label: string;
    filename?: string;
    link?: string;
    disabled?: boolean;
    onClick?: () => void;
    style?: CSSProperties;
    buttonColor?: "white" | "black";
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
}

export const FileButton = (props: FileButtonProps) => {
    const { buttonColor = "white", link, label, filename, disabled, onClick, style, leftIcon, rightIcon } = props;

    return (
        <a
            style={{ textDecoration: "none", width: "100%" }}
            href={link}
            download={filename}
            onClick={onClick}
            target="_blank"
            rel="noreferrer"
        >
            <div
                className={classNames(
                    styles["import-step-example-file"],
                    disabled ? styles["import-step-example-file-disabled"] : undefined,
                    buttonColor === "white" ? styles["white"] : styles["black"],
                )}
                style={style}
            >
                <div className={styles["file-button-left"]}>
                    {leftIcon ?? <FileSuccess color={buttonColor === "white" ? "#000" : "white"} />}
                    {label}
                </div>
                <div className={styles["file-button-right"]}>
                    {rightIcon ?? <Import color={buttonColor === "white" ? "#000" : "white"} />}
                </div>
            </div>
        </a>
    );
};
